import { IconButton } from "@material-ui/core";
import { PowerSettingsNew } from "@material-ui/icons";
import React from "react";
import { connect } from "react-redux";
import { auth } from "../../../firebase";
import { removeUser } from "../../../redux/actionProvider";
import "./Logout.css";

function Logout({ RemoveUserDispatch }) {
  const signOutHandler = () => {
    auth.signOut();
    RemoveUserDispatch();
  };
  return (
    <>
      <div className="logout">
        <IconButton
          style={{ backgroundColor: "#ff00009c" }}
          onClick={signOutHandler}
        >
          <PowerSettingsNew
            style={{
              color: "white",
            }}
          />
        </IconButton>
      </div>
      {/* <div>
        <p>Logout</p>
      </div> */}
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    RemoveUserDispatch: () => dispatch(removeUser()),
  };
};

export default connect(null, mapDispatchToProps)(Logout);
